module.exports = __webpack_public_path__ + "img/图1-19图板与丁字尺配合画线.29a698c9.png";